import type { CategoryType } from '@fs/zion-tree-types'
import { type TFunction } from 'i18next'

// Both tree-to-tree match categories share the "Matches From Other Trees" label.
const MATCHES_LABEL = 'tree-person.matches-from-other-trees.label'
const MATCHES_COUNT_LABEL = 'tree-person.matches-from-other-trees-count.label'

// Builds the section title for each category. Pass a `count` for the loaded state
// (e.g. "Record Hints (3)"); omit it for the loading skeletons, which use the
// count-less labels (e.g. "Record Hints").
export const getCategoryTitleMap = (t: TFunction, count?: number): Record<CategoryType, string> => {
  if (typeof count !== 'number') {
    return {
      'data-problems': t('tree-person.data-problems.label'),
      'record-hints': t('tree-person.record-hints.label'),
      'research-suggestions': t('tree-person.research-suggestions.label'),
      'quality-score-improvements': t('tree-person.quality-score-improvements.label'),
      'rejected-tree-to-tree-matches': t(MATCHES_LABEL),
      'tree-to-tree-matches': t(MATCHES_LABEL),
    }
  }

  return {
    'data-problems': t('tree-person.data-problems-count.label', { count }),
    'record-hints': t('tree-person.record-hints-count.label', { count }),
    'research-suggestions': t('tree-person.research-suggestions-count.label', { count }),
    'quality-score-improvements': t('tree-person.quality-score-improvements-count.label', { count }),
    'rejected-tree-to-tree-matches': t(MATCHES_COUNT_LABEL, { count }),
    'tree-to-tree-matches': t(MATCHES_COUNT_LABEL, { count }),
  }
}
